import {FC} from 'react';

import {Check} from '@mui/icons-material';
import {Checkbox, CheckboxProps, styled} from '@mui/material';

import {greenColors, orangeColors} from '../../../layouts/theme/designSystem';

const UICheckbox: FC<CheckboxProps> = styled((props: CheckboxProps) => (
  <Checkbox
    color='default'
    {...props}
    icon={<span className='checkbox-icon' />}
    checkedIcon={
      <span className='checkbox-icon-checked'>
        <Check />
      </span>
    }
  />
))(({theme}) => ({
  '& .checkbox-icon': {
    borderRadius: 3,
    width: 16,
    height: 16,
    backgroundColor: greenColors[100],
    border: `1px solid ${theme.palette.divider}`,
  },
  '& .checkbox-icon-checked': {
    backgroundColor: orangeColors[100],
    borderRadius: 3,
    width: 16,
    height: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      fontSize: 16,
      color: theme.palette.background.paper,
    },
  },
}));

export default UICheckbox;
